module.exports = __webpack_public_path__ + "static/img/backimg2.85b0eac1.png";